import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipoUnidadSunat',
  standalone: true,
})
export class TipoUnidadSunatPipe implements PipeTransform {
  private readonly labelMap = new Map<string, string>([
    ['4A', 'Bobinas'],
    ['BJ', 'Balde'],
    ['BLL', 'Barriles'],
    ['BG', 'Bolsa'],
    ['BO', 'Botellas'],
    ['BX', 'Caja'],
    ['CT', 'Cartones'],
    ['CMK', 'Centímetro cuadrado'],
    ['CMQ', 'Centímetro cúbico'],
    ['CMT', 'Centímetro lineal'],
    ['CEN', 'Ciento de unidades'],
    ['CY', 'Cilindro'],
    ['CJ', 'Conos'],
    ['DZN', 'Docena'],
    ['DZP', 'Docena por 10'],
    ['BE', 'Fardo'],
    ['GLI', 'Galón inglés'],
    ['GRM', 'Gramo'],
    ['GRO', 'Gruesa'],
    ['HLT', 'Hectolitro'],
    ['LEF', 'Hoja'],
    ['SET', 'Juego'],
    ['KGM', 'Kilogramo'],
    ['KTM', 'Kilómetro'],
    ['KWH', 'Kilovatio hora'],
    ['KT', 'Kit'],
    ['CA', 'Latas'],
    ['LBR', 'Libras'],
    ['LTR', 'Litro'],
    ['MWH', 'Megawatt hora'],
    ['MTR', 'Metro'],
    ['MTK', 'Metro cuadrado'],
    ['MTQ', 'Metro cúbico'],
    ['MGM', 'Miligramos'],
    ['MLT', 'Mililitro'],
    ['MMT', 'Milímetro'],
    ['MMK', 'Milímetro cuadrado'],
    ['MMQ', 'Milímetro cúbico'],
    ['MLL', 'Millares'],
    ['UM', 'Millón de unidades'],
    ['ONZ', 'Onzas'],
    ['PF', 'Paletas'],
    ['PK', 'Paquete'],
    ['PR', 'Par'],
    ['FOT', 'Pies'],
    ['FTK', 'Pies cuadrados'],
    ['FTQ', 'Pies cúbicos'],
    ['C62', 'Piezas'],
    ['PG', 'Placas'],
    ['ST', 'Pliego'],
    ['INH', 'Pulgadas'],
    ['RM', 'Resma'],
    ['DR', 'Tambor'],
    ['STN', 'Tonelada corta'],
    ['LTN', 'Tonelada larga'],
    ['TNE', 'Toneladas'],
    ['TU', 'Tubos'],
    ['NIU', 'Unidad bienes'],
    ['ZZ', 'Unidad servicios'],
    ['GLL', 'US galón 3L'],
    ['YRD', 'Yarda'],
    ['YDK', 'Yarda cuadrada'],
  ]);

  transform(value: string | null | undefined): string {
    if (!value) return '';
    return this.labelMap.get(value) || value;
  }
}
